import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Stack, Box, Typography, Button, Card, CardActionArea, CardMedia, CardContent, Divider, } from '@mui/material';
import { styled } from '@mui/material/styles';
import AssetImage from '../../../common/asset/AssetImage';
import SectionInfo from './CourseItemInfo';
import CustomButton from '../../../common/CustomButton';
import { WysiwygViewer } from '../../../../publisher/wysiwyg/WysiwygEditor';
import ItemMediaCard from './ItemMediaCard';
const StyledDivider = styled(Divider)(({ theme }) => ({
    borderColor: theme.portal.site.lineColor,
    borderBottomWidth: 1,
}));
const Instructors = ({ instructors, instructorAction, }) => {
    if (!instructors) {
        return null;
    }
    return (_jsx(Stack, { direction: "row", children: instructors.map((instructor) => (_jsxs(Stack, { direction: "row", children: [_jsx(Box, { sx: { width: 35, height: 35 }, children: _jsx(AssetImage, { avatar: true, asset: instructor.profileImage, customStyle: { width: '100%', height: '100%' }, size: "thumb400w" }) }), _jsx(Button, { onClick: () => (instructorAction && instructorAction(instructor.id)), sx: {
                        fontSize: 12,
                        marginY: 'auto',
                        padding: 0,
                        px: 0.875,
                        textTransform: 'none',
                    }, children: instructor.name })] }, instructor.id))) }));
};
const getLessonButtonLabel = (sectionItem) => {
    if (sectionItem.type === 'video') {
        return 'View Video';
    }
    if (sectionItem.type === 'audio') {
        return 'Listen to Audio';
    }
    if (sectionItem.type === 'quiz') {
        return 'Take Quiz';
    }
    if (sectionItem.type === 'knowledgeCheck') {
        return 'Take Knowledge Check';
    }
    if (sectionItem.type === 'article') {
        return 'View Article';
    }
    if (sectionItem.type === 'pdf') {
        return 'View PDF';
    }
    if (sectionItem.type === 'download') {
        return 'View Download';
    }
    if (sectionItem.type === 'certification') {
        return 'View Certification';
    }
    if (sectionItem.type === 'typeform') {
        return 'View Typeform';
    }
    return 'Open';
};
const LessonMediaCard = ({ item, portal, sectionItem, action, isProgram, }) => {
    const getImageAsset = () => {
        // console.log('sectionItem', sectionItem.type, sectionItem);
        if (sectionItem.type === 'microcast') {
            // console.log('microcastAsset');
            return sectionItem.microcast?.useAsPoster ? (sectionItem.microcast?.microcastImage) : sectionItem.microcast?.posterImage;
        }
        if (sectionItem.type === 'certification') {
            return sectionItem.certificateImage;
        }
        if (sectionItem.posterImage) {
            return sectionItem.posterImage;
        }
        return sectionItem.asset;
    };
    const imageAsset = getImageAsset();
    // console.log('imageAsset', imageAsset);
    // console.log('sectionItem', sectionItem, sectionItem.name);
    const image = (_jsx(Box, { sx: { width: '274px' }, children: _jsx(AssetImage
        // eslint-disable-next-line max-len
        , { 
            // eslint-disable-next-line max-len
            asset: imageAsset, customStyle: { width: 274, height: 154.13, objectFit: 'cover' }, size: imageAsset?.type === 'video' ? 'videoThumb' : 'thumb400w' }) }));
    return (
    // height 154.13 to maintiain 16:9
    _jsx(Card, { variant: "elevation", elevation: 0, sx: { px: 1.125, minHeight: 154.13 }, children: _jsx(CardContent, { sx: {
                p: '0 !important',
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
            }, children: isProgram && (sectionItem.type === 'course' || sectionItem.type === 'microcast')
                ? (_jsx(CardMedia, { children: _jsx(ItemMediaCard, { item: sectionItem.type === 'course' ? sectionItem.course : sectionItem.microcast }) }))
                : (_jsxs(_Fragment, { children: [_jsx(CardMedia, { sx: { maxWidth: '274px' }, children: action ? (_jsx(CardActionArea, { onClick: action, children: image })) : image }), _jsxs(Stack, { direction: "column", sx: { pl: 3.25, width: '100%', position: 'relative' }, children: [(sectionItem.instructors || sectionItem.length !== '') && (_jsxs(Stack, { children: [_jsx(StyledDivider, {}), _jsxs(Stack, { direction: "row", justifyContent: "space-between", sx: { py: 1.5 }, children: [_jsx(Instructors, { instructors: sectionItem.instructors, instructorAction: () => { } }), sectionItem.length !== '' && (_jsx(SectionInfo, { sectionItem: sectionItem }))] }), _jsx(StyledDivider, {})] })), _jsxs(Stack, { sx: {
                                        height: 154.13,
                                    }, children: [(sectionItem.headline || sectionItem.microcast?.headline)
                                            && (_jsx(Stack, { direction: "row", py: 1.5, children: _jsx(Typography, { variant: "h5", className: "landingpage-section-text", children: sectionItem.headline || sectionItem.microcast?.headline }) })), ['video', 'article', 'pdf', 'download', 'typeform'].includes(sectionItem.type)
                                            && sectionItem.content?.slate && (_jsx(Stack, { sx: {}, children: _jsx(WysiwygViewer, { id: sectionItem.id, value: sectionItem.content?.slate }) })), ['quiz', 'knowledgeCheck'].includes(sectionItem.type)
                                            && sectionItem.instructions?.slate && (_jsx(Stack, { sx: {}, children: _jsx(WysiwygViewer, { id: sectionItem.id, value: sectionItem.instructions?.slate }) })), sectionItem.type === 'microcast'
                                            && sectionItem.microcast?.content?.slate && (_jsx(Stack, { sx: {}, children: _jsx(WysiwygViewer, { id: sectionItem.id, value: sectionItem.microcast?.content?.slate }) })), sectionItem.type === 'certification' && (_jsx(Stack, { sx: {}, children: _jsx(WysiwygViewer, { id: sectionItem.id, value: sectionItem.certificateDescription?.slate }) })), isProgram && (portal.type === 'public' || item.checkAccess()) && (_jsx(Stack, { direction: "row", sx: { py: 1.5 }, children: _jsx(CustomButton, { variant: "outlined", label: getLessonButtonLabel(sectionItem), onClick: () => action && action(), customStyle: { flexGrow: 0, minWidth: '200px' } }) })), sectionItem.headline || ((sectionItem.type === 'video' && sectionItem.content?.slate)) ? (_jsx(Stack, { sx: {
                                                position: 'absolute',
                                                bottom: '0',
                                                left: '0',
                                                width: '100%',
                                                textAlign: 'center',
                                                margin: '0',
                                                padding: '30px',
                                                backgroundImage: (t) => (`linear-gradient(to bottom, ${t.portal.site.paper.color}ab, ${t.portal.site.paper.color})`),
                                            } })) : ''] })] })] })) }) }));
};
export default observer(LessonMediaCard);
//# sourceMappingURL=LessonMediaCard.js.map